module.exports = new __parcel__URL__("news09.bebe69a9.jpg").toString();